import { FillinProcess } from './containers/FillinProcess';
import FuelPrices from './containers/fuelsPrices/FuelPrices';
import InvoiceUpload from './containers/Invoice/InvoiceUpload';
import PendingStationBillingList from './containers/PendingStationBilling';
import PendingSubCompanyBillingList from './containers/PendingSubCompanyBilling';
import {
    AveragesReport,
    BlockedDriversReport,
    DetailedFillinsReport,
    DetailedPriceReport,
    DriverAveragesReport,
    FillinReport,
    FinancialReport,
    BillsReport,
    PriceChangesReport,
    PricesReport,
    TransactionsReport,
    VehicleAveragesReport,
    BestPricesReport,
    ConciliationReport,
    FillinLicenseReport,
    BillingForecastPaymentReport,
    BillingForecastReceivingReport,
    MarginReport,
} from "./containers/reports";

const customRoutes = [
    { path: '/transaction-report', element: <TransactionsReport /> },
    { path: '/average-report', element: <AveragesReport /> },
    { path: '/driver-average-report', element: <DriverAveragesReport /> },
    { path: '/vehicle-average-report', element: <VehicleAveragesReport /> },
    { path: '/fillin-report', element: <FillinReport /> },
    { path: '/detailed-fillins-report', element: <DetailedFillinsReport /> },
    { path: '/detailed-price-report', element: <DetailedPriceReport /> },
    { path: '/prices-report', element: <PricesReport /> },
    { path: '/financial-report', element: <FinancialReport /> },
    { path: '/price-changes-report', element: <PriceChangesReport /> },
    { path: '/bill-report', element: <BillsReport /> },
    { path: '/blocked-drivers-report', element: <BlockedDriversReport /> },
    { path: '/best-prices-report', element: <BestPricesReport /> },
    { path: '/fillin-process', element: <FillinProcess /> },
    { path: '/import-invoice', element: <InvoiceUpload /> },
    { path: '/conciliation-report', element: <ConciliationReport />},
    { path: '/fillin-license-report', element: <FillinLicenseReport />},
    { path: '/fuel-prices-edit', element: <FuelPrices />},
    { path: '/billing-forecast-payment-report', element: <BillingForecastPaymentReport />},
    { path: '/billing-forecast-receiving-report', element: <BillingForecastReceivingReport />},
    { path: '/margin-report', element: <MarginReport />},
    { path: '/pending-station-billing', element: <PendingStationBillingList />},
    { path: '/pending-subcompany-billing', element: <PendingSubCompanyBillingList />},
];

export default customRoutes;
